import { useQuery } from "@tanstack/react-query"
import { salesForceModelMapQuery } from "../../lib/salesForce/salesForceModelMapQuery"

export function useSalesForceModelMapQuery(...args: Parameters<typeof salesForceModelMapQuery>) {
  return useQuery(salesForceModelMapQuery(...args))
}
